import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { VideoExerciseView } from '../../views';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData28: ExerciseData = {
    ExerciseView: Module2Exercise8,
    dataKeys: [],
    questions: [],
};

function Module2Exercise8({ exercise, onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Så langt, så godt">
            <LabelDisplay2 class="mb-10 mt-20">Så langt, så godt</LabelDisplay2>
            <LabelBody>
                Du er nu ved slutningen af modul 2. Som afrunding på modulet,
                vil vi invitere dig til at vælge én ting du vil starte med at
                gøre i din hverdag, og én ting du vil stoppe med.
            </LabelBody>
            <VideoExerciseView className="my-30" exercise={exercise} />
            <SwirlyBox>
                Er du klar til at gå i gang med den næste øvelse?
            </SwirlyBox>
            <Spacer />
            <SecondaryButton
                class="mb-20 mt-30"
                onClick={() => {
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: '2.9',
                    });
                }}
            >
                Lad mig komme i gang
            </SecondaryButton>
            <GhostButton
                onClick={() => {
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    });
                }}
            >
                Vender tilbage senere
            </GhostButton>
        </Exercise>
    );
}
